import { render, staticRenderFns } from "./Error404.vue?vue&type=template&id=3bc8bae6&scoped=true&"
import script from "./Error404.vue?vue&type=script&lang=js&"
export * from "./Error404.vue?vue&type=script&lang=js&"
import style0 from "./Error404.vue?vue&type=style&index=0&id=3bc8bae6&lang=scss&scoped=true&"
import style1 from "./Error404.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc8bae6",
  null
  
)

export default component.exports